"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hooks = require("@nicbase/hooks");

var _classnames = _interopRequireDefault(require("classnames"));

var _nicbaseForms = require("nicbase-forms");

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseReducers = require("nicbase-reducers");

var _excluded = ["showHistoricalAssets", "hideCoupledAssets", "onFocus", "value", "eagerLoad", "resolvedLabel", "onChange"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var PaginatedAssetFilter = function PaginatedAssetFilter(_ref) {
  var showHistoricalAssets = _ref.showHistoricalAssets,
      hideCoupledAssets = _ref.hideCoupledAssets,
      onFocus = _ref.onFocus,
      value = _ref.value,
      eagerLoad = _ref.eagerLoad,
      resolvedLabel = _ref.resolvedLabel,
      onChange = _ref.onChange,
      props = _objectWithoutProperties(_ref, _excluded);

  var _usePortal = (0, _nicbaseReducers.usePortal)(),
      portalId = _usePortal.id;

  var _useState = (0, _react.useState)(eagerLoad),
      _useState2 = _slicedToArray(_useState, 2),
      enabled = _useState2[0],
      setEnabled = _useState2[1];

  var _useState3 = (0, _react.useState)(''),
      _useState4 = _slicedToArray(_useState3, 2),
      filterTerm = _useState4[0],
      setFilterTerm = _useState4[1];

  var fetchingRef = (0, _react.useRef)(false); // Current assets (paginated) — enabled only in non-historical mode

  var assetsResult = (0, _hooks.usePortalAssetsPaginated)(portalId, {
    enabled: Boolean(portalId) && enabled && !showHistoricalAssets,
    filter: filterTerm
  });
  var coupledAssetsResult = (0, _hooks.usePortalCoupledAssetsPaginated)(portalId, {
    enabled: Boolean(portalId) && enabled && !showHistoricalAssets,
    filter: filterTerm
  }); // Historical assets (paginated) — enabled only in historical mode

  var historicalAssetsResult = (0, _hooks.usePortalHistoricalAssetsPaginated)(portalId, {
    enabled: Boolean(portalId) && enabled && showHistoricalAssets,
    filter: filterTerm
  });
  var historicalCoupledAssetsResult = (0, _hooks.usePortalHistoricalCoupledAssetsPaginated)(portalId, {
    enabled: Boolean(portalId) && enabled && showHistoricalAssets,
    filter: filterTerm
  });

  var _ref2 = showHistoricalAssets ? historicalAssetsResult : assetsResult,
      fetchNextAssetsPage = _ref2.fetchNextPage,
      assetsHasNextPage = _ref2.hasNextPage,
      isFetchingNextAssetsPage = _ref2.isFetchingNextPage;

  var _ref3 = showHistoricalAssets ? historicalCoupledAssetsResult : coupledAssetsResult,
      fetchNextCoupledPage = _ref3.fetchNextPage,
      coupledHasNextPage = _ref3.hasNextPage,
      isFetchingNextCoupledPage = _ref3.isFetchingNextPage;

  var hasNextPage = assetsHasNextPage || coupledHasNextPage;
  var isFetchingNextPage = isFetchingNextAssetsPage || isFetchingNextCoupledPage;
  (0, _react.useEffect)(function () {
    if (!isFetchingNextPage) {
      fetchingRef.current = false;
    }
  }, [isFetchingNextPage]); // Auto-advance past pages where MySQL filtered out all MongoDB candidates (assets=[]) but
  // more pages exist. Without this the user has nothing to scroll, so handleFetchMore never
  // fires and they'd have to re-open the dropdown. Routes through fetchingRef to prevent
  // racing with a concurrent scroll-triggered handleFetchMore call.

  (0, _react.useEffect)(function () {
    var _historicalAssetsResu, _historicalAssetsResu2;

    if (!showHistoricalAssets || !enabled) return;
    var pages = (_historicalAssetsResu = (_historicalAssetsResu2 = historicalAssetsResult.data) === null || _historicalAssetsResu2 === void 0 ? void 0 : _historicalAssetsResu2.pages) !== null && _historicalAssetsResu !== void 0 ? _historicalAssetsResu : [];
    if (pages.length === 0) return;
    var lastPage = pages[pages.length - 1];

    if (lastPage.assets.length === 0 && historicalAssetsResult.hasNextPage && !historicalAssetsResult.isFetchingNextPage && !fetchingRef.current) {
      fetchingRef.current = true;
      historicalAssetsResult.fetchNextPage();
    }
  }, [showHistoricalAssets, enabled, historicalAssetsResult.data, historicalAssetsResult.hasNextPage, historicalAssetsResult.isFetchingNextPage]);
  (0, _react.useEffect)(function () {
    var _historicalCoupledAss, _historicalCoupledAss2;

    if (!showHistoricalAssets || !enabled) return;
    var pages = (_historicalCoupledAss = (_historicalCoupledAss2 = historicalCoupledAssetsResult.data) === null || _historicalCoupledAss2 === void 0 ? void 0 : _historicalCoupledAss2.pages) !== null && _historicalCoupledAss !== void 0 ? _historicalCoupledAss : [];
    if (pages.length === 0) return;
    var lastPage = pages[pages.length - 1];

    if (lastPage.coupledAssets.length === 0 && historicalCoupledAssetsResult.hasNextPage && !historicalCoupledAssetsResult.isFetchingNextPage && !fetchingRef.current) {
      fetchingRef.current = true;
      historicalCoupledAssetsResult.fetchNextPage();
    }
  }, [showHistoricalAssets, enabled, historicalCoupledAssetsResult.data, historicalCoupledAssetsResult.hasNextPage, historicalCoupledAssetsResult.isFetchingNextPage]);
  var handleFocus = (0, _react.useCallback)(function () {
    setEnabled(true);
    onFocus();
  }, [onFocus]);
  var handleQueryChange = (0, _react.useCallback)(function (query) {
    setFilterTerm(query);
  }, []);
  var handleFetchMore = (0, _react.useCallback)(function () {
    if (fetchingRef.current) return;
    fetchingRef.current = true;

    if (assetsHasNextPage && !isFetchingNextAssetsPage) {
      fetchNextAssetsPage();
    }

    if (coupledHasNextPage && !isFetchingNextCoupledPage) {
      fetchNextCoupledPage();
    }
  }, [fetchNextAssetsPage, fetchNextCoupledPage, assetsHasNextPage, coupledHasNextPage, isFetchingNextAssetsPage, isFetchingNextCoupledPage]);
  var source = (0, _react.useMemo)(function () {
    var allAssets = [];
    var allCoupled = [];

    if (showHistoricalAssets) {
      var _historicalAssetsResu3, _historicalAssetsResu4, _historicalCoupledAss3, _historicalCoupledAss4;

      allAssets = ((_historicalAssetsResu3 = (_historicalAssetsResu4 = historicalAssetsResult.data) === null || _historicalAssetsResu4 === void 0 ? void 0 : _historicalAssetsResu4.pages) !== null && _historicalAssetsResu3 !== void 0 ? _historicalAssetsResu3 : []).flatMap(function (p) {
        return p.assets;
      });
      allCoupled = hideCoupledAssets ? [] : ((_historicalCoupledAss3 = (_historicalCoupledAss4 = historicalCoupledAssetsResult.data) === null || _historicalCoupledAss4 === void 0 ? void 0 : _historicalCoupledAss4.pages) !== null && _historicalCoupledAss3 !== void 0 ? _historicalCoupledAss3 : []).flatMap(function (p) {
        return p.coupledAssets;
      });
    } else {
      var _assetsResult$data$pa, _assetsResult$data, _coupledAssetsResult$, _coupledAssetsResult$2;

      allAssets = ((_assetsResult$data$pa = (_assetsResult$data = assetsResult.data) === null || _assetsResult$data === void 0 ? void 0 : _assetsResult$data.pages) !== null && _assetsResult$data$pa !== void 0 ? _assetsResult$data$pa : []).flatMap(function (p) {
        return p.assets;
      });
      allCoupled = hideCoupledAssets ? [] : ((_coupledAssetsResult$ = (_coupledAssetsResult$2 = coupledAssetsResult.data) === null || _coupledAssetsResult$2 === void 0 ? void 0 : _coupledAssetsResult$2.pages) !== null && _coupledAssetsResult$ !== void 0 ? _coupledAssetsResult$ : []).flatMap(function (p) {
        return p.coupledAssets;
      });
    }

    return [].concat(_toConsumableArray(allAssets), _toConsumableArray(allCoupled)).reduce(function (result, asset) {
      var nextResult = result;
      nextResult[asset.id] = asset.name;
      return nextResult;
    }, {});
  }, [showHistoricalAssets, hideCoupledAssets, assetsResult.data, coupledAssetsResult.data, historicalAssetsResult.data, historicalCoupledAssetsResult.data]);
  var historicalOnlyIds = (0, _react.useMemo)(function () {
    var _historicalAssetsResu5, _historicalAssetsResu6, _historicalAssetsResu7, _historicalCoupledAss5, _historicalCoupledAss6, _historicalCoupledAss7;

    var allHistorical = (_historicalAssetsResu5 = (_historicalAssetsResu6 = historicalAssetsResult.data) === null || _historicalAssetsResu6 === void 0 ? void 0 : (_historicalAssetsResu7 = _historicalAssetsResu6.pages) === null || _historicalAssetsResu7 === void 0 ? void 0 : _historicalAssetsResu7.flatMap(function (p) {
      return p.assets;
    })) !== null && _historicalAssetsResu5 !== void 0 ? _historicalAssetsResu5 : [];
    var allHistoricalCoupled = (_historicalCoupledAss5 = (_historicalCoupledAss6 = historicalCoupledAssetsResult.data) === null || _historicalCoupledAss6 === void 0 ? void 0 : (_historicalCoupledAss7 = _historicalCoupledAss6.pages) === null || _historicalCoupledAss7 === void 0 ? void 0 : _historicalCoupledAss7.flatMap(function (p) {
      return p.coupledAssets;
    })) !== null && _historicalCoupledAss5 !== void 0 ? _historicalCoupledAss5 : [];
    return new Set([].concat(_toConsumableArray(allHistorical), _toConsumableArray(allHistoricalCoupled)).filter(function (a) {
      return a.isOnlyHistorical;
    }).map(function (a) {
      return a.id;
    }));
  }, [historicalAssetsResult.data, historicalCoupledAssetsResult.data]); // Inject the resolved label from the parent when the selected asset isn't in the fetched pages yet

  var resolvedSource = (0, _react.useMemo)(function () {
    if (!resolvedLabel || !value) return source;
    var id = Number(value);
    if (source[id] !== undefined) return source;
    return _objectSpread(_objectSpread({}, source), {}, _defineProperty({}, id, resolvedLabel));
  }, [source, resolvedLabel, value]); // Forward the selected asset's label to the parent so it can persist it as resolvedLabel
  // across the key-driven remount. Without this, greyscaled assets searched by text clear the
  // input after selection because source[value] is undefined on the fresh unfiltered query.

  var handleChange = (0, _react.useCallback)(function (newValue) {
    var _source$newValue;

    onChange(newValue, (_source$newValue = source[newValue]) !== null && _source$newValue !== void 0 ? _source$newValue : null);
  }, [onChange, source]);
  var optionRenderer = (0, _react.useCallback)(function (_ref4) {
    var isActive = _ref4.isActive,
        onOptionSelect = _ref4.onOptionSelect,
        measureRef = _ref4.measureRef,
        key = _ref4.key,
        style = _ref4.style,
        option = _ref4.option;
    var optionId = parseInt(option.value, 10);
    var isHistoric = historicalOnlyIds.has(optionId);
    return /*#__PURE__*/_react["default"].createElement("div", {
      ref: function ref(element) {
        return measureRef(element);
      },
      key: key,
      tabIndex: 0,
      style: style,
      role: "option",
      "aria-selected": isHistoric,
      className: (0, _classnames["default"])('bg-white hover:bg-gray-200 break-all text-base cursor-pointer p-1', {
        'text-primary': !isHistoric,
        'text-gray-500': isHistoric,
        'bg-gray-200': isActive
      }),
      onMouseDown: onOptionSelect
    }, option.label);
  }, [historicalOnlyIds]);
  var isInitialLoading = eagerLoad && (showHistoricalAssets ? historicalAssetsResult.isLoading || historicalCoupledAssetsResult.isLoading : assetsResult.isLoading || coupledAssetsResult.isLoading);
  return /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Autocomplete, _extends({}, props, {
    value: value,
    source: resolvedSource,
    onChange: handleChange,
    optionRenderer: showHistoricalAssets ? optionRenderer : undefined,
    debounceTime: 400,
    icon: /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Asset, null),
    valueType: "Integer",
    onFocus: handleFocus,
    onQueryChange: handleQueryChange,
    canFetchMore: hasNextPage || isInitialLoading,
    fetchMore: handleFetchMore,
    isFetchingMore: isFetchingNextPage || isInitialLoading
  }));
};

PaginatedAssetFilter.propTypes = _objectSpread(_objectSpread({}, _nicbaseForms.Autocomplete.propTypes), {}, {
  showHistoricalAssets: _propTypes["default"].bool,
  hideCoupledAssets: _propTypes["default"].bool,
  eagerLoad: _propTypes["default"].bool,
  onFocus: _propTypes["default"].func,
  onChange: _propTypes["default"].func,
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].arrayOf(_propTypes["default"].number)]),
  resolvedLabel: _propTypes["default"].string
});
PaginatedAssetFilter.defaultProps = _objectSpread(_objectSpread({}, _nicbaseForms.Autocomplete.defaultProps), {}, {
  showHistoricalAssets: false,
  hideCoupledAssets: false,
  eagerLoad: false,
  onFocus: function onFocus() {},
  onChange: function onChange() {},
  value: undefined,
  resolvedLabel: undefined
});
var _default = PaginatedAssetFilter;
exports["default"] = _default;